// we write all api calls here

import { endpoints } from "@app/api/apis";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import { getContentType } from "./util";
import { Platform } from "react-native";


export const getSupportingDocumentsByLender = async (payload: {
  applicationId: string;
}) => {

  let applicationId = payload.applicationId;
  let applicationIdStored = await AsyncStorage.getItem('application_id')

  if (applicationIdStored) {
    applicationId = applicationIdStored;
  }

  const updatedApplicationResponse = await axios.get(endpoints.borrowerApplication + applicationId);
  const currentStepId = updatedApplicationResponse?.data?.currentStepId;

  const response = await axios.get(endpoints.supportingDocumentInfoForLender + applicationId + '/' + currentStepId);
  return response.data;
}


export const getPresignedUrlForAdditionalDocumentToUploadAction = async (payload: {
  applicationId: string;
  documentType: string;
  currentStepId: string;
}) => {
  const response = await axios.get(endpoints.presignedUrlForAdditionalDocumentToUpload + payload.applicationId + '/' + payload.documentType  + '/' + payload.currentStepId);
  return response.data;
}



export const onSubmitForApproval = async (payload: {
  applicationId: string;
  currentStepId: string;
  frontFile: any;
  backFile?: any;
  documentType: string;
  frontPresignedUrl: string;
  frontFileExtension: string;
  backPresignedUrl?: string | null;
  backFileExtension?: string;
  imageNameFrontImage?: string;
  imageNameBackImage?: string | null;
}) => {

  // need to upload the document to the presigned url


  let responseFrontSide;
  let responseBackSide;





  // upload the front side document
  if(payload.frontFile && payload.frontPresignedUrl && payload.frontFileExtension){
      try {
        responseFrontSide = await fetch(payload.frontPresignedUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': getContentType(payload.frontFileExtension),
          },
          body: payload.frontFile,
        });
      
        if (!responseFrontSide.ok) {
          throw new Error(`Upload failed with status ${responseFrontSide.status}`);
        }
        } catch (error) {
        console.error(error, 'error');
       }
  }


  // upload the back side document

  if(payload.backFile && payload.backPresignedUrl && payload.backFileExtension){
    if(Platform.OS === 'web'){
      try {
        responseBackSide = await fetch(payload.backPresignedUrl, {
          method: 'PUT',
          headers: {  
            'Content-Type': getContentType(payload.backFileExtension),
          },
          body: payload.backFile,
        });
      } catch (error) {
        console.error(error, 'error');
      }
    }
  }


  if(responseFrontSide?.status === 200){
    try {
      return await makeAppeal({
        applicationId: payload.applicationId,
        currentStepId: payload.currentStepId,
        documentType: payload.documentType,
        frontFile: payload.frontFile,
        backFile: payload.backFile,
      responseFrontSide: responseFrontSide,
      responseBackSide: responseBackSide,
        frontImageName:  payload.imageNameFrontImage || null,
        backImageName: payload.imageNameBackImage || null,
      })
    } catch (error) {
      // console.error(error, 'error');
      throw error;
    }
  } else {

  }

  
  


  // need to call the appeal api after uploading the document



}


export const makeAppeal = async (payload: {
  applicationId: string;
  currentStepId: string;
  documentType: string;
  frontFile: any;
  backFile?: any;
  responseFrontSide: any;
  responseBackSide: any;
  frontImageName: string | null;
  backImageName: string | null;
}) => {

  const appealRequestBody = {
    applicationId: payload?.applicationId,
    stepId: payload?.currentStepId,
    documentType: payload?.documentType,
    ...payload?.frontImageName && {
        imageNameFrontImage: payload?.frontImageName,
    },
    ...payload?.backImageName && {
        imageNameBackImage: payload?.backImageName
    }
  }
  try {
    const response = await axios.post(endpoints.submitSupportDocuments, appealRequestBody);
    return response.data;
  } catch (error) {
    // console.error(error, 'error');
    throw error;
  }

}


